import React from 'react';
import { connect } from 'react-redux';
import T from 'prop-types';
// components
import { FormattedMessage } from 'react-intl';
// utils
import cn from 'classnames';
import { formatWater } from 'utils';

// Water volume formatter: backend stores gallons, metric companies see liters
const FormattedWater = ({
  className,
  hasOnlyValue = false,
  hasOnlyUnit = false,
  value,
  afterValue,
  measurementSystem,
  unitFontSize,
}) => {
  const messageKey = measurementSystem === 'metric' ? 'general.liters' : 'general.gallons';

  if (hasOnlyUnit) {
    return (
      <FormattedMessage id={messageKey}>
        {(text) => <span style={{ fontSize: unitFontSize }}>{text}</span>}
      </FormattedMessage>
    );
  }

  return (
    <span className={cn({ [className]: !!className })}>
      {formatWater(value, measurementSystem)}
      {afterValue}
      {!hasOnlyValue && !!value && (
        <FormattedMessage id={messageKey}>
          {(text) => <span className="ml-5" style={{ fontSize: unitFontSize }}>{text}</span>}
        </FormattedMessage>
      )}
    </span>
  );
};

FormattedWater.propTypes = {
  value: T.oneOfType([T.string, T.number]),
  afterValue: T.oneOfType([T.string, T.number]),
  hasOnlyValue: T.bool,
  hasOnlyUnit: T.bool,
  className: T.string,
  measurementSystem: T.string,
  unitFontSize: T.string,
};

export default connect(
  (state) => ({
    measurementSystem: state.auth.user.current_company.measurement_system,
  })
)(FormattedWater);
